import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const { API_DEVELOPER_URL } = environment;

@Injectable({
  providedIn: 'root'
})

export class EchartService {
  projectUrl: string;
  constructor(private http: HttpClient) {
    this.projectUrl = `${API_DEVELOPER_URL}/yp-api/project-api/api`;
  }
  getBuyerType(projectId) {
    return this.http.get(`${this.projectUrl}/auth/chart/group-by/project/buyer/firb?projectId=${projectId}`);
  }

  getPropertyStatus(projectId) {
    return this.http.get(`${this.projectUrl}/auth/chart/group-by/project/property/status?projectId=${projectId}`);
  }

  getDate(year, projectId) {
    return this.http.get(`${this.projectUrl}/auth/chart/group-by/project/property/summary/by-monthly?year=${year}&projectId=${projectId}`);
  }

  getPropertySaleChangeByYear(yearNum, projectId) {
    return this.http.get(`${this.projectUrl}/auth/chart/group-by/project/property/summary/by-annual?yearNumber=${yearNum}&projectId=${projectId}`);
  }
}
